// ChooseLocation.js
import React from 'react';
import Header from './Header';
import { useTranslation } from 'react-i18next';


const ValidationNumero = () => {
  const { t, i18n } = useTranslation('phone');


  return (
    <>
      <Header />

      <div className="container container-contact">
        <h2>{t('phone:verification')}</h2>
        <div className="valid-bloc">
          <div className="icon"></div>
          <p>{t('phone:done')}</p>
        </div>
      </div>
    </>
  );
}

export default ValidationNumero;
